import { useContext, useState } from 'react'
import { useTheme } from '@emotion/react'
import { Range } from 'chaoskit/src/components'

import { HeroTitleWrapper, HeroTitle } from '../Hero'

import { ReliabilityCalculatorContext } from './Context'

import {
  ReliabilityHelp,
  ReliabilityHelpTrigger,
  ReliabilityCell,
} from '~partials/reliability-calculator/UI'

const Step9 = () => {
  const theme = useTheme()

  const {
    state: { step9 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext)
  const [helpOpen, toggleHelpOpen] = useState(false)

  const mappedValues = {
    0: 'never',
    1: 'annually',
    2: 'quarterly',
    3: 'monthly',
    4: 'weekly',
    5: 'continuously',
  }

  const getKeyByValue = (value) =>
    Object.keys(mappedValues).find((key) => mappedValues[key] === value)

  return (
    <ReliabilityCell>
      {helpOpen ? (
        <ReliabilityHelp
          title="Chaos Engineering"
          toggleHelpOpen={toggleHelpOpen}
        >
          <p>
            Chaos Engineering is the practice of running thoughtful, planned
            experiments to learn how our systems behave in the face of failure.
          </p>
          <p>These experiments follow three steps:</p>
          <ol>
            <li>
              Form a hypothesis about how a system should behave when something
              goes wrong.
            </li>
            <li>
              Design the smallest possible experiment to test it in your system.
            </li>
            <li>
              Measure the impact of the failure at each step, looking for signs
              of success or failure.
            </li>
          </ol>
          <p>
            When the experiment is over, you have a better understanding of your
            system’s real-world behavior.
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="reliabilityCalculator__cell">
          <HeroTitleWrapper className="u-contrast" bottomSpace>
            <HeroTitle>
              How often do you practice{' '}
              <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
                Chaos Engineering{' '}
              </ReliabilityHelpTrigger>{' '}
              against this service ?
            </HeroTitle>
          </HeroTitleWrapper>
        </div>
      )}
      <Range
        contrast
        css={{
          marginTop: theme.space.xlarge,
        }}
        name="practice_range"
        type="range"
        min="0"
        max="5"
        step="1"
        value={getKeyByValue(step9)}
        onChange={({ target: { value } }) => {
          dispatch({
            type: 'choice',
            payload: {
              step9: mappedValues[value],
            },
          })
        }}
      />
      <div
        css={{
          textAlign: 'center',
          marginTop: theme.space.base,
        }}
        className="u-contrast"
      >
        <h4>{step9.charAt(0).toUpperCase() + step9.slice(1)}</h4>
      </div>
    </ReliabilityCell>
  )
}

export default Step9
